// React
import React, { Component, PropTypes } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import { configConst } from 'OMFECore/config-manager';
import { dataConst, DataManager } from 'OMFECore/data-manager';
import filterProps from 'SharedComponents/filterProps';
// Other Files
import uuidWrapper from 'SharedComponents/uuidWrapper';
import OddsBanner from './components/OddsBanner';
import 'OMFESelectors/services/timezoneselector';

@connect(
        (state, props) => {
            const bannerData = state[dataConst.STORE_PART][props.uuid];
            //RTT TODO change after migration of longer longs for everyone
            const matchData = props.matchId && bannerData && bannerData.match && bannerData.match.find(m => m.id == props.matchId);
            const sportId = matchData && matchData.sportId || undefined;
            const {match, score, minute, status, odds} = bannerData && bannerData.isLoaded && bannerData || {};

            //sportId: bettingTypeId
            const bettingTypeIds = {
                3: 466,
                5: 466,
                8: 466,
                9: 466,
                11: 466,
                14: 466,
                20: 466,
                25: 466,
                26: 466,
                28: 466,
                36: 466,
                38: 466,
                45: 466,
                60: 466,
                62: 466,
                63: 466,
                64: 466,
                67: 466,
                76: 466,
                89: 466,
                91: 466,
                98: 466,
                99: 466,
                100: 466,
                103: 466,
                105: 466,
                106: 466,
                107: 466,
                108: 466,
                109: 466,
                110: 466,
                112: 466,
                115: 466,
                117: 466,
                122: 466,
                123: 466,
                128: 466


            };
            //sportId: eventPartId
            const bettingEventPartIds = {
                1: 3,
                3: 20,
                5: 30,
                6: 41,
                7: 51,
                8: 60,
                9: 70,
                10: 91,
                11: 101,
                14: 310,
                20: 110,
                22: 121,
                25: 130,
                26: 230,
                28: 141,
                36: 260,
                38: 351,
                39: 151,
                40: 161,
                41: 171,
                45: 320,
                47: 191,
                49: 201,
                52: 250,
                60: 281,
                62: 331,
                63: 240,
                64: 210,
                66: 221,
                67: 340,
                73: 592,
                76: 601,
                77: 529,
                89: 588,
                93: 812,
                98: 1901,
                99: 1895,
                100: 1889,
                103: 1432,
                105: 1460,
                106: 1471,
                107: 1486,
                108: 1495,
                109: 1503,
                110: 1511,
                112: 1813,
                115: 1807,
                117: 2109,
                121: 2255,
                122: 2163,
                123: 2245,
                128: 2268,
                129: 2343,

            };
            const rootEventPartId = props.matchId && matchData && matchData.rootPartId || undefined;

            return {
                match: matchData,
                score: bannerData && bannerData.score && bannerData.score[0] || null,
                status: bannerData && bannerData.status && bannerData.status[0] || null,
                minute: bannerData && bannerData.minute && bannerData.minute[0] || null,
                odds: bannerData && bannerData.odds || null,

                isLoading:
                        !match ||
                        !sportId && !rootEventPartId && !odds ||
                        sportId && bettingTypeIds[sportId] && bettingEventPartIds[sportId] && !odds || false,

                // Computed
                rootEventPartId: rootEventPartId,
                bettingTypeId: sportId && bettingTypeIds[sportId] || 69,
                bettingEventPartId: sportId && bettingEventPartIds[sportId] || undefined,
                scoreInfoTypeId: 1,
                minuteInfoTypeId: 95,
                eventStatusTypeId: 92,


                providerId: state[configConst.STORE_PART].operatorInfo && state[configConst.STORE_PART].operatorInfo.providerId,

                ucsOperatorId: state[configConst.STORE_PART].operatorInfo && state[configConst.STORE_PART].operatorInfo.ucsOperatorId,
                apiVersion: state[configConst.STORE_PART].operatorInfo && state[configConst.STORE_PART].operatorInfo.apiVersion,

                defaultLanguage: state[configConst.STORE_PART].language,
                defaultTimezone: state[configConst.STORE_PART].timezone,
                defaultOddsFormat: state[configConst.STORE_PART].oddsFormat,
            };
        },
        dispatch => bindActionCreators({}, dispatch)
)
    /**
     * Data provisioning wrapper around the actual OddsBanner component - acquires match data, event info and odds
     * and passes down as props to presentation component. Loads OddsBanner automatically, there is no way to disable this.
     */
class EmptyOMFEOddsBanner extends Component {

    static propTypes = {

        ucsOperatorId: PropTypes.any,
        apiVersion: PropTypes.any,

        /** Match to display */
        matchId: PropTypes.any,

        /** Language to request from server */
        language: PropTypes.string,

        /** Timezone to display dates in */
        timezone: PropTypes.string,

        /** Odds format for the underlying OddsButton */
        oddsFormat: PropTypes.string,

        providerId: PropTypes.any,
        defaultLanguage: PropTypes.any,
        defaultTimezone: PropTypes.any,
        defaultOddsFormat: PropTypes.any,
        uuid: PropTypes.any.isRequired,

        match: PropTypes.any,
        score: PropTypes.any,
        minute: PropTypes.any,
        odds: PropTypes.any,
        isLoading: PropTypes.bool.isRequired,

        rootEventPartId: PropTypes.any,

        bettingTypeId: PropTypes.any,
        bettingEventPartId: PropTypes.any,
        scoreInfoTypeId: PropTypes.any,
        minuteInfoTypeId: PropTypes.any,
        eventStatusTypeId: PropTypes.any,

    }

    componentWillMount(){
        this.dm = new DataManager(this.props.uuid);
        this.resubscribe(this.props);
    }

    componentWillUpdate(nextProps){
        this.resubscribe(nextProps);
    }

    componentWillUnmount(){
        this.dm.unsub('match', 'unsubscribeFromMatch');
        this.dm.unsub('score', 'unsubscribeFromEventInfo');
        this.dm.unsub('minute', 'unsubscribeFromEventInfo');
        this.dm.unsub('status', 'unsubscribeFromEventInfo');
        this.dm.unsub('odds', 'unsubscribeFromMatchOdds');
        this.dm.done();
    }

    resubscribe({
                    ucsOperatorId,
                    apiVersion,
                    defaultLanguage,
                    language,
                    matchId,
                    providerId,
                    rootEventPartId,
                    bettingTypeId, bettingEventPartId,
                    scoreInfoTypeId,
                    minuteInfoTypeId,
                    eventStatusTypeId,
                }){
        const lang = language || defaultLanguage || 'en';


        // resubscribe to match
        if (
                ucsOperatorId !== this.ucsOperatorId ||
                apiVersion !== this.apiVersion ||
                lang !== this.lang ||
                matchId !== this.matchId ||
                providerId !== this.providerId ||
                scoreInfoTypeId !== this.scoreInfoTypeId ||
                bettingTypeId !== this.bettingTypeId ||
                minuteInfoTypeId !== this.minuteInfoTypeId ||
                eventStatusTypeId !== this.eventStatusTypeId ||
                rootEventPartId !== this.rootEventPartId ||
                bettingEventPartId !== this.bettingEventPartId
        ){

            if (
                    ucsOperatorId !== this.ucsOperatorId ||
                    apiVersion !== this.apiVersion ||
                    lang !== this.lang ||
                    matchId !== this.matchId
            ){
                this.dm.unsub('match', 'unsubscribeFromMatch');
                if (lang && matchId){
                    this.dm.sub('match', 'subscribeToMatch', {ucsOperatorId, apiVersion, lang, matchId});
                }
            }

            if (
                    ucsOperatorId !== this.ucsOperatorId ||
                    apiVersion !== this.apiVersion ||
                    lang !== this.lang ||
                    matchId !== this.matchId ||
                    scoreInfoTypeId !== this.scoreInfoTypeId ||
                    rootEventPartId !== this.rootEventPartId
            ){
                this.dm.unsub('score', 'unsubscribeFromEventInfo');
                if (lang && matchId && scoreInfoTypeId && rootEventPartId){
                    this.dm.sub('score', 'subscribeToEventInfo', {
                        ucsOperatorId,
                        apiVersion,
                        lang,
                        matchId,
                        eventInfoType: scoreInfoTypeId,
                        eventPartId: rootEventPartId
                    });
                }
            }

            if (
                    ucsOperatorId !== this.ucsOperatorId ||
                    apiVersion !== this.apiVersion ||
                    lang !== this.lang ||
                    matchId !== this.matchId ||
                    minuteInfoTypeId !== this.minuteInfoTypeId ||
                    rootEventPartId !== this.rootEventPartId
            ){
                this.dm.unsub('minute', 'unsubscribeFromEventInfo');
                if (lang && matchId && minuteInfoTypeId && rootEventPartId){
                    this.dm.sub('minute', 'subscribeToEventInfo', {
                        ucsOperatorId,
                        apiVersion,
                        lang,
                        matchId,
                        eventInfoType: minuteInfoTypeId,
                        eventPartId: rootEventPartId
                    });
                }
            }

            if (
                    ucsOperatorId !== this.ucsOperatorId ||
                    apiVersion !== this.apiVersion ||
                    lang !== this.lang ||
                    matchId !== this.matchId ||
                    eventStatusTypeId !== this.eventStatusTypeId ||
                    rootEventPartId !== this.rootEventPartId
            ){
                this.dm.unsub('status', 'unsubscribeFromEventInfo');
                if (lang && matchId && eventStatusTypeId && rootEventPartId){
                    this.dm.sub('status', 'subscribeToEventInfo', {
                        ucsOperatorId,
                        apiVersion,
                        lang,
                        matchId,
                        eventInfoType: eventStatusTypeId,
                        eventPartId: rootEventPartId
                    });
                }
            }


            if (
                    ucsOperatorId !== this.ucsOperatorId ||
                    apiVersion !== this.apiVersion ||
                    lang !== this.lang ||
                    matchId !== this.matchId ||
                    providerId !== this.providerId ||
                    bettingTypeId !== this.bettingTypeId ||
                    bettingEventPartId !== this.bettingEventPartId
            ){
                this.dm.unsub('odds', 'unsubscribeFromMatchOdds');
                if (lang && matchId && providerId && bettingTypeId && rootEventPartId){
                    this.dm.sub('odds', 'subscribeToMatchOdds', {
                        ucsOperatorId,
                        apiVersion,
                        lang,
                        matchId,
                        providerId,
                        bettingTypeId,
                        eventPartId: bettingEventPartId
                    });
                }
            }

            this.ucsOperatorId = ucsOperatorId;
            this.apiVersion = apiVersion;

            this.lang = lang;
            this.matchId = matchId;
            this.providerId = providerId;

            this.rootEventPartId = rootEventPartId;

            this.bettingTypeId = bettingTypeId;
            this.bettingEventPartId = bettingEventPartId;
            this.scoreInfoTypeId = scoreInfoTypeId;
            this.minuteInfoTypeId = minuteInfoTypeId;
            this.eventStatusTypeId = eventStatusTypeId;

        }
    }

    render(){
        const {matchId, match, score, minute, status, odds, oddsFormat, defaultOddsFormat, timezone, defaultTimezone, isLoading, ...restProps} = this.props;

        const newProps = {
            matchId,
            match: match || {},
            score: score || {},
            minute: minute || {},
            status: status || {},
            odds: odds || {},
            timezone: timezone || defaultTimezone || undefined,
            oddsFormat: oddsFormat || defaultOddsFormat,
            isLoading,
            ...filterProps(restProps, this.constructor.propTypes || {}),
        };

        return (
                <OddsBanner {...newProps} />
        );
    }
}

export default uuidWrapper(EmptyOMFEOddsBanner);



// WEBPACK FOOTER //
// ./src/OMFEOddsBanner/OMFEOddsBanner.js